module.exports = __webpack_public_path__ + "static/media/c-logo.6282ffde.png";